import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteVesselProduct } from '../../../common/api/clients/vessel.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useDeleteVesselProduct = (vesselId: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (productId: string) => deleteVesselProduct(vesselId, productId),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: queries.vessels.detail(vesselId)._ctx.products.queryKey,
            });
        },
    });
};
